// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import React, { useEffect, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import { useLocation } from 'react-use';
// import { Table } from 'semantic-ui-react';
// import LoadingAnimation from '../../../../components/LoadingAnimation';
// import LoaderModal from '../../../../components/common/LoaderModal';
// import SliderImageModal from '../../../../components/elements/SliderImageModal';
// import { getAsync, postAsync, putAsync } from '../../../../components/helper/axiosHelper';
// import { PageHitCountApi } from '../../../../shared/Helper';

// const BannerDashboard = () => {
//   const [modalImage, setModalImage] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [activeInactiveBefore, setActiveInactiveBefore] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [dataChanged, setDataChanged] = useState(false);
//   const [sliderDetails, setSliderDetails] = useState({
//     name: '',
//     link: '',
//     note: '',
//     rank: null,
//   });
//   const [threeImages, setThreeImages] = useState({
//     file1: null,
//     file2: null,
//     file3: null,
//   });
//   const [apiData, setApiData] = useState([]);
//   const [pageOptions, setPageOptions] = useState({
//     page: 1,
//     pageSize: 10,
//   });
//   const desktopRef = useRef();
//   const tabletRef = useRef();
//   const mobileRef = useRef();
//   const { pathname } = useLocation();

//   useEffect(() => {
//     const adminID = localStorage.getItem('apid');
//     if (adminID) {
//       PageHitCountApi(pathname, adminID);
//     }
//   }, []);

//   const { t } = useTranslation();
//   useEffect(() => {
//     localStorage.setItem('isHome', false);
//   }, []);

//   useEffect(() => {
//     localStorage.setItem('isHome', false);
//     getApiData();
//   }, [dataChanged]);

//   // Handle multiple image uploads
//   const handleImageChange = (e) => {
//     const { name } = e.target;
//     const file = e.target.files[0];
//     const imag = file.name.split('.')[1];
//     const fileSize = file.size;

//     if (
//       (imag === 'png' || imag === 'jpg' || imag === 'jpeg' || imag === 'PNG' || imag === 'JPG') &&
//       fileSize <= 2097152
//     ) {
//       setThreeImages((prev) => ({
//         ...prev,
//         [name]: file,
//       }));
//     } else {
//       desktopRef.current.value = null;
//       tabletRef.current.value = null;
//       mobileRef.current.value = null;
//       toast.error(t('Uploaded File must contain these formats [jpg, png, jpeg] and must not be greater than 2 MBs'));
//     }
//   };
//   // Handle input changes for slider details
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setSliderDetails({ ...sliderDetails, [name]: value });
//   };

//   // Save slider details
//   // const body = {
//   //   SliderID: 0,
//   //   SliderName: sliderDetails.name,
//   //   SliderLink: sliderDetails.link,
//   //   SliderNotes: sliderDetails.note,
//   //   SliderRank: sliderDetails.rank,
//   //   ActiveID: activeInactiveBefore,
//   //   UserID: 100,

//   // }

//   //  sending data to API
//   const saveSlider = () => {
//     const formData = new FormData();

//     // Add other form fields
//     formData.append('SliderID', 0);
//     formData.append('SliderName', sliderDetails.name);
//     formData.append('SliderLink', sliderDetails.link);
//     formData.append('SliderNotes', sliderDetails.note);
//     formData.append('SliderRank', sliderDetails.rank);
//     formData.append('ActiveID', activeInactiveBefore);
//     formData.append('UserID', 100);
//     formData.append('files', threeImages?.file3);
//     formData.append('files', threeImages?.file2);
//     formData.append('files', threeImages?.file1);

//     // if (valueStore) {
//     //   for (let i = 0; i < valueStore.length; i++) {
//     //     formData.append('files', valueStore[i]);
//     //   }
//     // }

//     // Call the API using fetch or axios
//     postAsync(
//       'CMS_Slider/CreateSlider',
//       formData,
//       {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       },
//       'multipart/form-data',
//     )
//       .then((response) => {
//         setDataChanged((prev) => !prev);
//         setSliderDetails({
//           name: '',
//           link: '',
//           note: '',
//           rank: '',
//         });
//         setActiveInactiveBefore(1);
//         desktopRef.current.value = null;
//         tabletRef.current.value = null;
//         mobileRef.current.value = null;
//       })
//       .catch((error) => console.error('Error:', error));
//   };

//   // get data from API without images
//   const getApiData = async () => {
//     // setIsloading(true);
//     await postAsync(`CMS_Slider/GetCMSSliderList/${pageOptions.page}/${pageOptions.pageSize}`, {}).then((response) => {
//       // console.log('response', response.data);
//       setApiData(response.data);
//       // setIsloading(false);
//     });
//   };

//   // get images from API
//   const getImages = async (id, btnId) => {
//     setIsLoading(true);
//     try {
//       const response = await getAsync(`CMS_Slider/GetByIdCMSSlider`, { id });

//       if (response.statusCode === 204) {
//         // setDatanotfound(true);
//         setIsLoading(false);
//         return;
//       }

//       const result = response.data[0];
//       setIsLoading(false);

//       if (btnId === 1) {
//         openModal(result.sliderImage1);
//       } else if (btnId === 2) {
//         openModal(result.sliderImage2);
//       } else if (btnId === 3) {
//         openModal(result.sliderImage3);
//       } else {
//         console.error('Invalid button ID');
//       }
//     } catch (error) {
//       setIsLoading(false);
//       console.error('Error fetching images:', error);
//     }
//   };

//   // Get Active InAcitve Data
//   const getActiveInactive = async (sliderId, id) => {
//     // setIsloading(true);
//     await putAsync(`CMS_Slider/ActiveSliderAsync`, { ActiveID: id }, { id: sliderId }).then((response) => {
//       if (response.statusCode == 200) {
//         setDataChanged((prev) => !prev);
//       }
//       // setApiData(response.data);
//       // setIsloading(false);
//     });
//   };

//   // Open modal to view the image
//   const openModal = (image) => {
//     setModalImage(image);
//     setIsModalOpen(true);
//   };

//   // Close modal
//   const closeModal = () => {
//     setModalImage(null);
//     setIsModalOpen(false);
//   };

//   // Toggle active status
//   const toggleActiveStatus = (index, status) => {
//     // console.log('statusstatus', status);
//     // setActiveInactiveAfter(status);
//     // const updatedSliders = savedSliders.map((slider, i) =>
//     //   i === index ? { ...slider, ActiveID: status } : slider
//     // );
//     // setSavedSliders(updatedSliders);
//   };

//   return (
//     <div className="container-fluid pb-4">
//       <div className="row justify-center">
//         <div className="col-lg-11  justify-center my-4">
//           <div className=" min-h-screen">
//             <h2 className="text-3xl font-bold text-customgreen mb-4 text-center">{t('Sliders Dashboard')}</h2>

//             {/* Display Saved Sliders in a Table */}
//             <div className="mb-4">
//               <div className=" flex justify-end items-center ">
//                 <Link
//                   href="#slidersForm"
//                   className="w-44 m-0 group hover:text-white hover:bg-hovergreen  rounded-full bg-customgreen mb-3 py-2"
//                   onClick={(e) => {
//                     e.preventDefault(); // Prevent default behavior
//                     document.getElementById('slidersForm')?.scrollIntoView({ behavior: 'smooth' });
//                   }}
//                 >
//                   <button className="  text-white group-hover:bg-hovergreen  rounded-full cursor-pointer">
//                     {t('Create Slider')}
//                   </button>
//                 </Link>

//               </div>
//               <h3 className="text-2xl text-customgreen font-bold  mb-4">{t('Saved Sliders')}</h3>
//               {apiData?.length > 0 ? (
//                 <div className=" overflow-x-auto shadow-md sm:rounded-lg">
//                   <Table className="tableData  text-center  rtl:text-right ">
//                     <Table.Header className="font-bold text-sm whitespace-nowrap  text-white bg-customgreen uppercase ">
//                       <Table.Row className="">
//                         <Table.HeaderCell className="text-white">{t('S.No')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Name')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Link')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Note')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Rank')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('View')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
//                         <Table.HeaderCell className="text-white">{t('Active')}</Table.HeaderCell>
//                       </Table.Row>
//                     </Table.Header>
//                     <Table.Body>
//                       {apiData?.map((slider, index) => (
//                         <Table.Row className="text-sm" key={index}>
//                           <Table.Cell>{index + 1}</Table.Cell>
//                           <Table.Cell>{slider.sliderName}</Table.Cell>
//                           <Table.Cell>
//                             <Link to={`${slider.sliderLink}`}>{slider.sliderLink}</Link>
//                             {/* <a href={slider.sliderLink} className="text-green-600 hover:underline">

//                       </a> */}
//                           </Table.Cell>
//                           <Table.Cell>{slider.sliderNotes}</Table.Cell>
//                           <Table.Cell>{slider.sliderRank}</Table.Cell>
//                           <Table.Cell className="flex flex-col space-y-2">
//                             {[1, 2, 3].map((imgIndex) => {
//                               const sliderLabels = [
//                                 t('View Desktop Slider'),
//                                 t('View Tablet Slider'),
//                                 t('View Mobile Slider'),
//                               ];

//                               return (
//                                 <div key={imgIndex} className="flex items-center  justify-between space-x-2">
//                                   {/* Label */}
//                                   <span className="text-black text-sm font-medium">{t`${sliderLabels[imgIndex - 1]}`}</span>
//                                   {/* Button */}
//                                   <button
//                                     onClick={() => getImages(slider.sliderID, imgIndex)}
//                                     className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 text-center"
//                                   >
//                                     <VisibilityOutlinedIcon />
//                                   </button>
//                                 </div>
//                               );
//                             })}
//                           </Table.Cell>
//                           <Table.Cell>
//                             <div className="flex items-center mt-2">
//                               {slider.activeID === 1 ? (
//                                 <label
//                                   style={{
//                                     backgroundColor: 'lightgreen',
//                                     fontWeight: 'bold',
//                                     color: 'green',
//                                     padding: '5px',
//                                     width: '70px',
//                                     textAlign: 'center',
//                                     borderRadius: '5px',
//                                   }}
//                                 >
//                                   {t('Active')}
//                                 </label>
//                               ) : (
//                                 <label
//                                   style={{
//                                     backgroundColor: 'lightpink',
//                                     fontWeight: 'bold',
//                                     color: 'red',
//                                     padding: '5px',
//                                     width: '70px',
//                                     textAlign: 'center',
//                                     borderRadius: '5px',
//                                   }}
//                                 >
//                                   {t('Inactive')}
//                                 </label>
//                               )}
//                             </div>
//                           </Table.Cell>
//                           <Table.Cell>
//                             <div>
//                               <div className="flex items-center">
//                                 <input
//                                   type="radio"
//                                   name={`status-${index}`} // Group radio buttons for each slider
//                                   value={slider.activeID}
//                                   checked={slider.activeID === 1}
//                                   onChange={() => getActiveInactive(slider.sliderID, 1)}
//                                   className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
//                                   style={{
//                                     accentColor: 'green', // Makes the radio button green when checked
//                                   }}
//                                 />
//                                 <label>{t('Active')}</label>
//                               </div>
//                               <div className="flex items-center">
//                                 <input
//                                   type="radio"
//                                   name={`status-${index}`} // Group radio buttons for each slider
//                                   checked={slider.activeID === 2}
//                                   value={slider.activeID}
//                                   onChange={() => getActiveInactive(slider.sliderID, 2)}
//                                   className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
//                                   style={{
//                                     accentColor: 'green', // Makes the radio button green when checked
//                                   }}
//                                 />
//                                 <label>{t('Inactive')}</label>
//                               </div>
//                             </div>
//                           </Table.Cell>
//                         </Table.Row>
//                       ))}
//                     </Table.Body>
//                   </Table>
//                 </div>
//               ) : (
//                 <>
//                   <LoadingAnimation />
//                 </>
//               )}
//               {isLoading && <LoaderModal />}
//             </div>

//             {/* Form Section */}
//             <div id="slidersForm" className="bg-white p-6 rounded-lg shadow-lg">
//               {/* Image Upload */}
//               <div className="mb-6">
//                 <label className="block text-customgreen mb-2">
//                   {t('Upload Image for Desktop')}{' '}
//                   <span className="text-red-700">{t('(Image Dimensions should be: 1920x550)')}</span>
//                 </label>
//                 <input
//                   type="file"
//                   name="file1"
//                   ref={desktopRef}
//                   accept=".png, .jpeg, .jpg, .JPG, .PNG"
//                   onChange={(e) => handleImageChange(e)}
//                   className="block w-full mb-3"
//                 />
//                 {threeImages.file1 && (
//                   <img
//                     src={URL.createObjectURL(threeImages.file1)}
//                     alt="Desktop Preview"
//                     className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
//                   />
//                 )}

//                 <label className="block text-customgreen mb-2">
//                   {t('Upload Image for Tablet')}
//                   <span className="text-red-700"> {t('(Image Dimensions should be: 1600x900)')}</span>
//                 </label>
//                 <input
//                   type="file"
//                   name="file2"
//                   ref={tabletRef}
//                   accept=".png, .jpeg, .jpg, .JPG, .PNG"
//                   onChange={(e) => handleImageChange(e)}
//                   className="block w-full mb-3"
//                 />
//                 {threeImages.file2 && (
//                   <img
//                     src={URL.createObjectURL(threeImages.file2)}
//                     alt="Tablet Preview"
//                     className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
//                   />
//                 )}

//                 <label className="block text-customgreen mb-2">
//                   {t('Upload Image for Mobile')}
//                   <span className="text-red-700"> {t('(Image Dimensions should be: 1080x720)')}</span>{' '}
//                 </label>
//                 <input
//                   type="file"
//                   name="file3"
//                   ref={mobileRef}
//                   accept=".png, .jpeg, .jpg, .JPG, .PNG"
//                   onChange={(e) => handleImageChange(e)}
//                   className="block w-full mb-3"
//                 />
//                 {threeImages.file3 && (
//                   <div className="flex gap-4">
//                     <img
//                       src={URL.createObjectURL(threeImages.file3)}
//                       alt="Mobile Preview"
//                       className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
//                     />
//                   </div>
//                 )}
//               </div>

//               {/* Slider Details */}
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
//                 <div>
//                   <label className="block text-green-700 mb-2" htmlFor="name">
//                     {t('Slider Name')}
//                   </label>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     value={sliderDetails.name}
//                     onChange={handleInputChange}
//                     className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-green-700 mb-2" htmlFor="link">
//                     {t('Slider Link')}
//                   </label>
//                   <input
//                     type="text"
//                     id="link"
//                     name="link"
//                     value={sliderDetails.link}
//                     onChange={handleInputChange}
//                     className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
//                   />
//                 </div>
//                 <div className="md:col-span-2">
//                   <label className="block text-green-700 mb-2" htmlFor="note">
//                     {t('Slider Note')}
//                   </label>
//                   <textarea
//                     id="note"
//                     name="note"
//                     value={sliderDetails.note}
//                     onChange={handleInputChange}
//                     className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-green-700 mb-2" htmlFor="rank">
//                     {t('Slider Rank')}
//                   </label>
//                   <input
//                     type="number"
//                     id="rank"
//                     name="rank"
//                     value={sliderDetails.rank}
//                     onChange={handleInputChange}
//                     className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
//                   />
//                 </div>
//                 <div className=" flex  justify-end items-end">
//                   <div>
//                     <input
//                       type="radio"
//                       name="status"
//                       value={1}
//                       checked={activeInactiveBefore === 1}
//                       onChange={() => {
//                         setActiveInactiveBefore(1);
//                       }}
//                       className="text-customgreen  mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
//                       style={{ accentColor: 'green' }}
//                     />
//                     {t('Active')}
//                   </div>
//                   <div>
//                     <input
//                       type="radio"
//                       name="status"
//                       value={2}
//                       checked={activeInactiveBefore === 2}
//                       onChange={() => setActiveInactiveBefore(2)}
//                       className="text-customgreen  mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
//                       style={{ accentColor: 'green' }}
//                     />
//                     {t('Inactive')}
//                   </div>
//                 </div>
//               </div>

//               {/* Save Button */}
//               <div className="text-right">
//                 <button className="bg-customgreen text-white rounded-full px-6 py-2" onClick={saveSlider}>
//                   {t('Save Slider')}
//                 </button>
//               </div>
//             </div>

//             {/* Modal */}

//             {/* <ImageViewModal
//         showModal={isModalOpen}
//         setShowModal={setIsModalOpen}
//         closeModal={closeModal}
//         imgDoc={modalImage}
//         renderLink={""}
//       /> */}
//             <SliderImageModal
//               showModal={isModalOpen}
//               setShowModal={setIsModalOpen}
//               closeModal={closeModal}
//               imgDoc={modalImage}
//               renderLink={''}
//             />

//             {/* {isModalOpen && (

//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
//           <div className="bg-white p-6 rounded-lg shadow-lg max-w-md">
//             <img src={modalImage} alt="Slider Image" className="w-full h-auto mb-4" />
//             <button
//               onClick={closeModal}
//               className="bg-customgreen text-white rounded-md px-4 py-2"
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )} */}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BannerDashboard;

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { Table } from 'semantic-ui-react';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import LoaderModal from '../../../../components/common/LoaderModal';
import SliderImageModal from '../../../../components/elements/SliderImageModal';
import { getAsync, postAsync, putAsync, deleteAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';

const BannerDashboard = () => {
  const [modalImage, setModalImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [activeInactiveBefore, setActiveInactiveBefore] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [dataChanged, setDataChanged] = useState(false);
  const [sliderDetails, setSliderDetails] = useState({
    name: '',
    link: '',
    note: '',
    rank: null,
  });
  const [currentSlider, setCurrentSlider] = useState(null);
  const [threeImages, setThreeImages] = useState({
    file1: null,
    file2: null,
    file3: null,
  });
  const [apiData, setApiData] = useState([]);
  const [pageOptions, setPageOptions] = useState({
    page: 1,
    pageSize: 10,
  });
  const desktopRef = useRef();
  const tabletRef = useRef();
  const mobileRef = useRef();
  const updateDesktopRef = useRef();
  const updateTabletRef = useRef();
  const updateMobileRef = useRef();
  const { pathname } = useLocation();

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const { t } = useTranslation();
  useEffect(() => {
    localStorage.setItem('isHome', false);
  }, []);

  useEffect(() => {
    localStorage.setItem('isHome', false);
    getApiData();
  }, [dataChanged]);

  // Handle multiple image uploads
  const handleImageChange = (e, isUpdate = false) => {
    const { name } = e.target;
    const file = e.target.files[0];
    const imag = file.name.split('.')[1];
    const fileSize = file.size;

    if (
      (imag === 'png' || imag === 'jpg' || imag === 'jpeg' || imag === 'PNG' || imag === 'JPG') &&
      fileSize <= 2097152
    ) {
      if (isUpdate) {
        setCurrentSlider((prev) => ({
          ...prev,
          [name]: file,
        }));
      } else {
        setThreeImages((prev) => ({
          ...prev,
          [name]: file,
        }));
      }
    } else {
      const ref = isUpdate
        ? name === 'file1'
          ? updateDesktopRef
          : name === 'file2'
            ? updateTabletRef
            : updateMobileRef
        : name === 'file1'
          ? desktopRef
          : name === 'file2'
            ? tabletRef
            : mobileRef;
      ref.current.value = null;
      toast.error(t('Uploaded File must contain these formats [jpg, png, jpeg] and must not be greater than 2 MBs'));
    }
  };

  // Handle input changes for slider details
  const handleInputChange = (e, isUpdate = false) => {
    const { name, value } = e.target;
    if (isUpdate) {
      setCurrentSlider((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setSliderDetails({ ...sliderDetails, [name]: value });
    }
  };

  // Save slider details
  const saveSlider = () => {
    const formData = new FormData();

    // Add other form fields
    formData.append('SliderID', 0);
    formData.append('SliderName', sliderDetails.name);
    formData.append('SliderLink', sliderDetails.link);
    formData.append('SliderNotes', sliderDetails.note);
    formData.append('SliderRank', sliderDetails.rank);
    formData.append('ActiveID', activeInactiveBefore);
    formData.append('UserID', 100);
    formData.append('files', threeImages?.file3);
    formData.append('files', threeImages?.file2);
    formData.append('files', threeImages?.file1);

    postAsync(
      'CMS_Slider/CreateSlider',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      'multipart/form-data',
    )
      .then((response) => {
        setDataChanged((prev) => !prev);
        setSliderDetails({
          name: '',
          link: '',
          note: '',
          rank: '',
        });
        setActiveInactiveBefore(1);
        desktopRef.current.value = null;
        tabletRef.current.value = null;
        mobileRef.current.value = null;
        toast.success(t('Slider created successfully'));
      })
      .catch((error) => {
        console.error('Error:', error);
        toast.error(t('Error creating slider'));
      });
  };

  // Update slider details
  const updateSlider = () => {
    const formData = new FormData();

    // Add other form fields
    formData.append('SliderID', currentSlider.sliderID);
    formData.append('SliderName', currentSlider.sliderName);
    formData.append('SliderLink', currentSlider.sliderLink);
    formData.append('SliderNotes', currentSlider.sliderNotes);
    formData.append('SliderRank', currentSlider.sliderRank);
    formData.append('ActiveID', currentSlider.activeID);
    formData.append('UserID', 100);

    // Only append files if they are changed
    if (currentSlider.file1) formData.append('files', currentSlider.file1);
    if (currentSlider.file2) formData.append('files', currentSlider.file2);
    if (currentSlider.file3) formData.append('files', currentSlider.file3);

    putAsync(
      'CMS_Slider/UpdateSlider',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      'multipart/form-data',
    )
      .then((response) => {
        setDataChanged((prev) => !prev);
        setIsUpdateModalOpen(false);
        toast.success(t('Slider updated successfully'));
      })
      .catch((error) => {
        console.error('Error:', error);
        toast.error(t('Error updating slider'));
      });
  };

  // Delete slider
  const onDelete = async (id) => {
    try {
      const response = await deleteAsync(
        'CMS_Slider/DeleteSliderAsync',
        { id },
        {
          headers: {
            id,
          },
        },
      );

      if (response.statusCode === 200) {
        setDataChanged((prev) => !prev);
        toast.success(t('Slider deleted successfully'));
      } else {
        toast.error(t('Failed to delete slider'));
      }
    } catch (error) {
      console.error('Error deleting slider:', error);
      toast.error(t('Error deleting slider'));
    }
  };

  // get data from API without images
  const getApiData = async () => {
    setIsLoading(true);
    await postAsync(`CMS_Slider/GetCMSSliderList/${pageOptions.page}/${pageOptions.pageSize}`, {})
      .then((response) => {
        setApiData(response.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  };

  // get images from API
  const getImages = async (id, btnId) => {
    setIsLoading(true);
    try {
      const response = await getAsync(`CMS_Slider/GetByIdCMSSlider`, { id });

      if (response.statusCode === 204) {
        setIsLoading(false);
        return;
      }

      const result = response.data[0];
      setIsLoading(false);

      if (btnId === 1) {
        openModal(result.sliderImage1);
      } else if (btnId === 2) {
        openModal(result.sliderImage2);
      } else if (btnId === 3) {
        openModal(result.sliderImage3);
      } else {
        console.error('Invalid button ID');
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching images:', error);
    }
  };

  // Open modal for update
  // const openUpdateModal = (slider) => {
  //   setCurrentSlider({
  //     ...slider,
  //     file1: null,
  //     file2: null,
  //     file3: null,
  //     sliderName: slider.sliderName,
  //     sliderLink: slider.sliderLink,
  //     sliderNotes: slider.sliderNotes,
  //     sliderRank: slider.sliderRank,
  //     activeID: slider.activeID,
  //     sliderID: slider.sliderID,
  //   });
  //   setIsUpdateModalOpen(true);
  // };

  // const openUpdateModal = async (slider) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await getAsync(`CMS_Slider/GetByIdCMSSlider`, { id: slider.sliderID });

  //     if (response.statusCode === 204) {
  //       toast.error(t('Slider details not found'));
  //       return;
  //     }

  //     const sliderDetails = response.data[0];
  //     setCurrentSlider({
  //       ...sliderDetails,
  //       file1: null,
  //       file2: null,
  //       file3: null,
  //       existingImage1: sliderDetails.sliderImage1,
  //       existingImage2: sliderDetails.sliderImage2,
  //       existingImage3: sliderDetails.sliderImage3,
  //       sliderName: sliderDetails.sliderName,
  //       sliderLink: sliderDetails.sliderLink,
  //       sliderNotes: sliderDetails.sliderNotes,
  //       sliderRank: sliderDetails.sliderRank,
  //       activeID: sliderDetails.activeID,
  //       sliderID: sliderDetails.sliderID,
  //     });
  //     setIsUpdateModalOpen(true);
  //   } catch (error) {
  //     console.error('Error fetching slider details:', error);
  //     toast.error(t('Error loading slider details'));
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const openUpdateModal = async (slider) => {
    setIsLoading(true);
    try {
      const response = await getAsync(`CMS_Slider/GetByIdCMSSlider`, { id: slider.sliderID });

      if (response.statusCode === 204) {
        toast.error(t('Slider details not found'));
        return;
      }

      const sliderDetails = response.data[0];
      setCurrentSlider({
        ...sliderDetails,
        file1: null,
        file2: null,
        file3: null,
        existingImage1: sliderDetails.sliderImage1 ? `data:image/jpeg;base64,${sliderDetails.sliderImage1}` : null,
        existingImage2: sliderDetails.sliderImage2 ? `data:image/jpeg;base64,${sliderDetails.sliderImage2}` : null,
        existingImage3: sliderDetails.sliderImage3 ? `data:image/jpeg;base64,${sliderDetails.sliderImage3}` : null,
        sliderName: sliderDetails.sliderName,
        sliderLink: sliderDetails.sliderLink,
        sliderNotes: sliderDetails.sliderNotes,
        sliderRank: sliderDetails.sliderRank,
        activeID: sliderDetails.activeID,
        sliderID: sliderDetails.sliderID,
      });
      setIsUpdateModalOpen(true);
    } catch (error) {
      console.error('Error fetching slider details:', error);
      toast.error(t('Error loading slider details'));
    } finally {
      setIsLoading(false);
    }
  };

  // Get Active InAcitve Data
  const getActiveInactive = async (sliderId, id) => {
    await putAsync(`CMS_Slider/ActiveSliderAsync`, { ActiveID: id }, { id: sliderId }).then((response) => {
      if (response.statusCode == 200) {
        setDataChanged((prev) => !prev);
        toast.success(t('Status updated successfully'));
      }
    });
  };

  // Open modal to view the image
  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  // Close modal
  const closeModal = () => {
    setModalImage(null);
    setIsModalOpen(false);
  };

  // Close update modal
  const closeUpdateModal = () => {
    setIsUpdateModalOpen(false);
    setCurrentSlider(null);
  };

  return (
    <div className="container-fluid pb-4">
      <div className="row justify-center">
        <div className="col-lg-11  justify-center my-4">
          <div className=" min-h-screen">
            <h2 className="text-3xl font-bold text-customgreen mb-4 text-center">{t('Sliders Dashboard')}</h2>

            {/* Display Saved Sliders in a Table */}
            <div className="mb-4">
              <div className=" flex justify-end items-center ">
                <Link
                  href="#slidersForm"
                  className="w-44 m-0 group hover:text-white hover:bg-hovergreen  rounded-full bg-customgreen mb-3 py-2"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById('slidersForm')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <button className="  text-white group-hover:bg-hovergreen  rounded-full cursor-pointer">
                    {t('Create Slider')}
                  </button>
                </Link>
              </div>
              <h3 className="text-2xl text-customgreen font-bold  mb-4">{t('Saved Sliders')}</h3>
              {apiData?.length > 0 ? (
                <div className=" overflow-x-auto shadow-md sm:rounded-lg">
                  <Table className="tableData  text-center  rtl:text-right ">
                    <Table.Header className="font-bold text-sm whitespace-nowrap  text-white bg-customgreen uppercase ">
                      <Table.Row className="">
                        <Table.HeaderCell className="text-white">{t('S.No')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Name')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Link')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Note')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Rank')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('View')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Active')}</Table.HeaderCell>
                        <Table.HeaderCell className="text-white">{t('Actions')}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {apiData?.map((slider, index) => (
                        <Table.Row className="text-sm" key={index}>
                          <Table.Cell>{index + 1}</Table.Cell>
                          <Table.Cell>{slider.sliderName}</Table.Cell>
                          <Table.Cell>
                            <Link to={`${slider.sliderLink}`}>{slider.sliderLink}</Link>
                          </Table.Cell>
                          <Table.Cell>{slider.sliderNotes}</Table.Cell>
                          <Table.Cell>{slider.sliderRank}</Table.Cell>
                          <Table.Cell className="flex flex-col space-y-2">
                            {[1, 2, 3].map((imgIndex) => {
                              const sliderLabels = [
                                t('View Desktop Slider'),
                                t('View Tablet Slider'),
                                t('View Mobile Slider'),
                              ];

                              return (
                                <div key={imgIndex} className="flex items-center  justify-between space-x-2">
                                  <span className="text-black text-sm font-medium">{t`${sliderLabels[imgIndex - 1]}`}</span>
                                  <button
                                    onClick={() => getImages(slider.sliderID, imgIndex)}
                                    className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 text-center"
                                  >
                                    <VisibilityOutlinedIcon />
                                  </button>
                                </div>
                              );
                            })}
                          </Table.Cell>
                          <Table.Cell>
                            <div className="flex items-center mt-2">
                              {slider.activeID === 1 ? (
                                <label
                                  style={{
                                    backgroundColor: 'lightgreen',
                                    fontWeight: 'bold',
                                    color: 'green',
                                    padding: '5px',
                                    width: '70px',
                                    textAlign: 'center',
                                    borderRadius: '5px',
                                  }}
                                >
                                  {t('Active')}
                                </label>
                              ) : (
                                <label
                                  style={{
                                    backgroundColor: 'lightpink',
                                    fontWeight: 'bold',
                                    color: 'red',
                                    padding: '5px',
                                    width: '70px',
                                    textAlign: 'center',
                                    borderRadius: '5px',
                                  }}
                                >
                                  {t('Inactive')}
                                </label>
                              )}
                            </div>
                          </Table.Cell>
                          <Table.Cell>
                            <div>
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  name={`status-${index}`}
                                  value={slider.activeID}
                                  checked={slider.activeID === 1}
                                  onChange={() => getActiveInactive(slider.sliderID, 1)}
                                  className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                                  style={{
                                    accentColor: 'green',
                                  }}
                                />
                                <label>{t('Active')}</label>
                              </div>
                              <div className="flex items-center">
                                <input
                                  type="radio"
                                  name={`status-${index}`}
                                  checked={slider.activeID === 2}
                                  value={slider.activeID}
                                  onChange={() => getActiveInactive(slider.sliderID, 2)}
                                  className="text-customgreen p-1 m-1 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                                  style={{
                                    accentColor: 'green',
                                  }}
                                />
                                <label>{t('Inactive')}</label>
                              </div>
                            </div>
                          </Table.Cell>
                          <Table.Cell>
                            <div className="flex space-x-2">
                              <button
                                onClick={() => openUpdateModal(slider)}
                                className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center"
                              >
                                {t('Update')}
                              </button>
                              <button
                                onClick={() => onDelete(slider.sliderID)}
                                className="text-white bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-5 py-2 text-center"
                              >
                                {t('Delete')}
                              </button>
                            </div>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>
              ) : (
                <>
                  <LoadingAnimation />
                </>
              )}
              {isLoading && <LoaderModal />}
            </div>

            {/* Form Section */}
            <div id="slidersForm" className="bg-white p-6 rounded-lg shadow-lg">
              {/* Image Upload */}
              <div className="mb-6">
                <label className="block text-customgreen mb-2">
                  {t('Upload Image for Desktop')}{' '}
                  <span className="text-red-700">{t('(Image Dimensions should be: 1920x550)')}</span>
                </label>
                <input
                  type="file"
                  name="file1"
                  ref={desktopRef}
                  accept=".png, .jpeg, .jpg, .JPG, .PNG"
                  onChange={(e) => handleImageChange(e)}
                  className="border w-full text-customgreen text-sm rounded-lg focus:!ring-customgreen focus:!border-customgreen mb-3"
                />
                {threeImages.file1 && (
                  <img
                    src={URL.createObjectURL(threeImages.file1)}
                    alt="Desktop Preview"
                    className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                  />
                )}

                <label className="block text-customgreen mb-2">
                  {t('Upload Image for Tablet')}
                  <span className="text-red-700"> {t('(Image Dimensions should be: 1600x900)')}</span>
                </label>
                <input
                  type="file"
                  name="file2"
                  ref={tabletRef}
                  accept=".png, .jpeg, .jpg, .JPG, .PNG"
                  onChange={(e) => handleImageChange(e)}
                  className="border w-full text-customgreen text-sm rounded-lg focus:!ring-customgreen focus:!border-customgreen mb-3"
                />
                {threeImages.file2 && (
                  <img
                    src={URL.createObjectURL(threeImages.file2)}
                    alt="Tablet Preview"
                    className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                  />
                )}

                <label className="block text-customgreen mb-2">
                  {t('Upload Image for Mobile')}
                  <span className="text-red-700"> {t('(Image Dimensions should be: 1080x720)')}</span>{' '}
                </label>
                <input
                  type="file"
                  name="file3"
                  ref={mobileRef}
                  accept=".png, .jpeg, .jpg, .JPG, .PNG"
                  onChange={(e) => handleImageChange(e)}
                  className="border w-full text-customgreen text-sm rounded-lg focus:!ring-customgreen focus:!border-customgreen mb-3"
                />
                {threeImages.file3 && (
                  <div className="flex gap-4">
                    <img
                      src={URL.createObjectURL(threeImages.file3)}
                      alt="Mobile Preview"
                      className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                    />
                  </div>
                )}
              </div>

              {/* Slider Details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-green-700 mb-2" htmlFor="name">
                    {t('Slider Name')}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={sliderDetails.name}
                    onChange={handleInputChange}
                    className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                  />
                </div>
                <div>
                  <label className="block text-green-700 mb-2" htmlFor="link">
                    {t('Slider Link')}
                  </label>
                  <input
                    type="text"
                    id="link"
                    name="link"
                    value={sliderDetails.link}
                    onChange={handleInputChange}
                    className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-green-700 mb-2" htmlFor="note">
                    {t('Slider Note')}
                  </label>
                  <textarea
                    id="note"
                    name="note"
                    value={sliderDetails.note}
                    onChange={handleInputChange}
                    className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                  />
                </div>
                <div>
                  <label className="block text-green-700 mb-2" htmlFor="rank">
                    {t('Slider Rank')}
                  </label>
                  <input
                    type="number"
                    id="rank"
                    name="rank"
                    value={sliderDetails.rank}
                    onChange={handleInputChange}
                    className=" border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                  />
                </div>
                <div className=" flex  justify-end items-end">
                  <div>
                    <input
                      type="radio"
                      name="status"
                      value={1}
                      checked={activeInactiveBefore === 1}
                      onChange={() => {
                        setActiveInactiveBefore(1);
                      }}
                      className="text-customgreen  mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                      style={{ accentColor: 'green' }}
                    />
                    {t('Active')}
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="status"
                      value={2}
                      checked={activeInactiveBefore === 2}
                      onChange={() => setActiveInactiveBefore(2)}
                      className="text-customgreen  mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm  text-center"
                      style={{ accentColor: 'green' }}
                    />
                    {t('Inactive')}
                  </div>
                </div>
              </div>

              {/* Save Button */}
              <div className="text-right">
                <button className="bg-customgreen text-white rounded-full px-6 py-2" onClick={saveSlider}>
                  {t('Save Slider')}
                </button>
              </div>
            </div>

            {/* Update Modal */}
            {isUpdateModalOpen && currentSlider && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-4xl w-full max-h-screen overflow-y-auto">
                  <h3 className="text-2xl font-bold text-customgreen mb-4">{t('Update Slider')}</h3>

                  {/* Image Upload */}
                  {/* <div className="mb-6">
                    <label className="block text-customgreen mb-2">
                      {t('Update Desktop Image')}{' '}
                      <span className="text-red-700">{t('(Image Dimensions should be: 1920x550)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file1"
                      ref={updateDesktopRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    {currentSlider.file1 ? (
                      <img
                        src={URL.createObjectURL(currentSlider.file1)}
                        alt="Desktop Preview"
                        className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                      />
                    ) : (
                      <div className="text-sm text-gray-500">{t('No new image selected')}</div>
                    )}

                    <label className="block text-customgreen mb-2">
                      {t('Update Tablet Image')}
                      <span className="text-red-700"> {t('(Image Dimensions should be: 1600x900)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file2"
                      ref={updateTabletRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    {currentSlider.file2 ? (
                      <img
                        src={URL.createObjectURL(currentSlider.file2)}
                        alt="Tablet Preview"
                        className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                      />
                    ) : (
                      <div className="text-sm text-gray-500">{t('No new image selected')}</div>
                    )}

                    <label className="block text-customgreen mb-2">
                      {t('Update Mobile Image')}
                      <span className="text-red-700"> {t('(Image Dimensions should be: 1080x720)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file3"
                      ref={updateMobileRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    {currentSlider.file3 ? (
                      <img
                        src={URL.createObjectURL(currentSlider.file3)}
                        alt="Mobile Preview"
                        className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                      />
                    ) : (
                      <div className="text-sm text-gray-500">{t('No new image selected')}</div>
                    )}
                  </div> */}
                  <div className="mb-6">
                    <label className="block text-customgreen mb-2">
                      {t('Update Desktop Image')}{' '}
                      <span className="text-red-700">{t('(Image Dimensions should be: 1920x550)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file1"
                      ref={updateDesktopRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    <div className="flex items-center space-x-4">
                      {currentSlider.file1 ? (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('New Image:')}</p>
                          <img
                            src={URL.createObjectURL(currentSlider.file1)}
                            alt="Desktop Preview"
                            className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                          />
                        </div>
                      ) : (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('Current Image:')}</p>
                          {currentSlider.existingImage1 ? (
                            <img
                              src={currentSlider.existingImage1}
                              alt="Current Desktop"
                              className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                            />
                          ) : (
                            <div className="w-32 h-32 flex items-center justify-center border-2 border-gray-300 rounded-md text-sm text-gray-500">
                              {t('No image')}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <label className="block text-customgreen mb-2 mt-4">
                      {t('Update Tablet Image')}
                      <span className="text-red-700"> {t('(Image Dimensions should be: 1600x900)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file2"
                      ref={updateTabletRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    <div className="flex items-center space-x-4">
                      {currentSlider.file2 ? (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('New Image:')}</p>
                          <img
                            src={URL.createObjectURL(currentSlider.file2)}
                            alt="Tablet Preview"
                            className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                          />
                        </div>
                      ) : (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('Current Image:')}</p>
                          {currentSlider.existingImage2 ? (
                            <img
                              src={currentSlider.existingImage2}
                              alt="Current Tablet"
                              className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                            />
                          ) : (
                            <div className="w-32 h-32 flex items-center justify-center border-2 border-gray-300 rounded-md text-sm text-gray-500">
                              {t('No image')}
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    <label className="block text-customgreen mb-2 mt-4">
                      {t('Update Mobile Image')}
                      <span className="text-red-700"> {t('(Image Dimensions should be: 1080x720)')}</span>
                    </label>
                    <input
                      type="file"
                      name="file3"
                      ref={updateMobileRef}
                      accept=".png, .jpeg, .jpg, .JPG, .PNG"
                      onChange={(e) => handleImageChange(e, true)}
                      className="block w-full mb-3"
                    />
                    <div className="flex items-center space-x-4">
                      {currentSlider.file3 ? (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('New Image:')}</p>
                          <img
                            src={URL.createObjectURL(currentSlider.file3)}
                            alt="Mobile Preview"
                            className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                          />
                        </div>
                      ) : (
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{t('Current Image:')}</p>
                          {currentSlider.existingImage3 ? (
                            <img
                              src={currentSlider.existingImage3}
                              alt="Current Mobile"
                              className="w-32 h-32 object-cover border-2 border-gray-300 rounded-md"
                            />
                          ) : (
                            <div className="w-32 h-32 flex items-center justify-center border-2 border-gray-300 rounded-md text-sm text-gray-500">
                              {t('No image')}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Slider Details */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label className="block text-green-700 mb-2" htmlFor="update-name">
                        {t('Slider Name')}
                      </label>
                      <input
                        type="text"
                        id="update-name"
                        name="sliderName"
                        value={currentSlider.sliderName}
                        onChange={(e) => handleInputChange(e, true)}
                        className="border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                      />
                    </div>
                    <div>
                      <label className="block text-green-700 mb-2" htmlFor="update-link">
                        {t('Slider Link')}
                      </label>
                      <input
                        type="text"
                        id="update-link"
                        name="sliderLink"
                        value={currentSlider.sliderLink}
                        onChange={(e) => handleInputChange(e, true)}
                        className="border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-green-700 mb-2" htmlFor="update-note">
                        {t('Slider Note')}
                      </label>
                      <textarea
                        id="update-note"
                        name="sliderNotes"
                        value={currentSlider.sliderNotes}
                        onChange={(e) => handleInputChange(e, true)}
                        className="border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                      />
                    </div>
                    <div>
                      <label className="block text-green-700 mb-2" htmlFor="update-rank">
                        {t('Slider Rank')}
                      </label>
                      <input
                        type="number"
                        id="update-rank"
                        name="sliderRank"
                        value={currentSlider.sliderRank}
                        onChange={(e) => handleInputChange(e, true)}
                        className="border border-customgreen focus:ring-customgreen rounded-md p-2 w-full"
                      />
                    </div>

                    <div className="flex justify-end items-end">
                      <div>
                        <input
                          type="radio"
                          name="update-status"
                          value={1}
                          checked={currentSlider.activeID === 1}
                          onChange={() => setCurrentSlider((prev) => ({ ...prev, activeID: 1 }))}
                          className="text-customgreen mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm text-center"
                          style={{ accentColor: 'green' }}
                        />
                        {t('Active')}
                      </div>
                      <div>
                        <input
                          type="radio"
                          name="update-status"
                          value={2}
                          checked={currentSlider.activeID === 2}
                          onChange={() => setCurrentSlider((prev) => ({ ...prev, activeID: 2 }))}
                          className="text-customgreen mx-2 focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm text-center"
                          style={{ accentColor: 'green' }}
                        />
                        {t('Inactive')}
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={closeUpdateModal}
                      className="bg-customgreen text-white rounded-full px-6 py-2 hover:bg-hovergreen"
                    >
                      {t('Cancel')}
                    </button>
                    <button
                      onClick={updateSlider}
                      className="bg-customgreen text-white rounded-full px-6 py-2 hover:bg-hovergreen"
                    >
                      {t('Update Slider')}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Image View Modal */}
            <SliderImageModal
              showModal={isModalOpen}
              setShowModal={setIsModalOpen}
              closeModal={closeModal}
              imgDoc={modalImage}
              renderLink={''}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerDashboard;
